import React from "react";
import { Wand2 } from "lucide-react";
import { AdvisorChat } from "../components/AdvisorChat";
import { useLang } from "../i18n/LanguageContext";

export default function Advisor() {
  const { t } = useLang();
  return (
    <div className="pt-24 pb-16 container-lumeo">
      <div className="text-center max-w-2xl mx-auto mb-8">
        <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl hairline shadow-glow-cyan mx-auto"><Wand2 className="h-7 w-7 text-cyanx" /></span>
        <h1 className="mt-4 font-display text-3xl sm:text-4xl">{t("advisor.title")}</h1>
        <p className="mt-3 text-muted-foreground">{t("advisor.subtitle")}</p>
      </div>
      <AdvisorChat layout="split" />
    </div>
  );
}
